import * as React from 'react';
import { Book as BookType } from '../../../../types/Book';
import { CardsManagerCallbacks } from '../../../CardsManager/CardsManager';
import FindBook from '../../../Header/FindBook/FindBook';
import BookItem from './BookItem/BookItem';
import { FieldArray } from 'react-final-form-arrays';

interface Props {
	callbacks: CardsManagerCallbacks;
}

const bookReducer: React.Reducer<BookType[], { payload: BookType | string; type: string }> = (state, action) => {
	switch (action.type) {
		case 'add':
			return [...state, action.payload as BookType];
		case 'remove':
			return state.filter(row => row.externalId !== action.payload);
		default:
			return state;
	}
}

const BooksList: React.FC<Props> = props => {
	const [bookState, dispatch] = React.useReducer(bookReducer, []);

	return <>
		<FieldArray name="books">
			{({ fields }) => <>
				{
					bookState.map((book, index) => {
						console.log(fields);

						return <BookItem
							book={book}
							key={index}
							index={index}
							updateValue={fields.update}
							value={fields.value[index]}
							onDelete={() => {
								fields.remove(index);

								dispatch({
									payload: book.externalId,
									type: 'remove'
								})
							}}
						/>
					})
				}
			
				<div>
					<FindBook
						withoutInitial={true}
						callbacks={props.callbacks}
						onBookSelect={(book) => {
							fields.push({
								externalId: book.externalId,
								bookName: book.name,
								bookDesc: book.description,
								bookType: book
							})

							dispatch({
								payload: book,
								type: 'add'
							})
						}}
					/>
				</div>
			</>
			}
		</FieldArray>
	</>;
};

export default BooksList;
